import React from 'react';

interface GlassCTAProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
}

export function GlassCTA({
  variant = 'primary',
  children,
  disabled,
  className = '',
  ...props
}: GlassCTAProps) {
  if (variant === 'secondary') {
    return (
      <button
        type="button"
        disabled={disabled}
        className={`text-sm transition-all duration-200 ${className}`}
        style={{
          color: 'rgba(255, 255, 255, 0.5)',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.3 : 1,
        }}
        onMouseEnter={(e) => {
          if (!disabled)
            e.currentTarget.style.color = 'rgba(255, 255, 255, 0.85)';
        }}
        onMouseLeave={(e) => {
          if (!disabled)
            e.currentTarget.style.color = 'rgba(255, 255, 255, 0.5)';
        }}
        {...props}
      >
        {children}
      </button>
    );
  }

  return (
    <button
      type="button"
      disabled={disabled}
      className={`group relative rounded-xl px-8 py-3.5 font-medium transition-all duration-200 ${className}`}
      style={{
        background: disabled ? 'rgba(255, 255, 255, 0.4)' : 'rgba(255, 255, 255, 0.92)',
        color: '#111114',
        opacity: disabled ? 0.3 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
        boxShadow: disabled
          ? '0 2px 12px rgba(0, 0, 0, 0.15)'
          : '0 2px 12px rgba(0, 0, 0, 0.15), 0 0 20px rgba(255, 255, 255, 0.08)',
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.currentTarget.style.background = '#FFFFFF';
          e.currentTarget.style.boxShadow =
            '0 4px 20px rgba(0, 0, 0, 0.2), 0 0 30px rgba(255, 255, 255, 0.12)';
          e.currentTarget.style.transform = 'translateY(-1px)';
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled) {
          e.currentTarget.style.background = 'rgba(255, 255, 255, 0.92)';
          e.currentTarget.style.boxShadow =
            '0 2px 12px rgba(0, 0, 0, 0.15), 0 0 20px rgba(255, 255, 255, 0.08)';
          e.currentTarget.style.transform = 'translateY(0)';
        }
      }}
      onMouseDown={(e) => {
        if (!disabled) {
          e.currentTarget.style.transform = 'scale(0.97)';
        }
      }}
      onMouseUp={(e) => {
        if (!disabled) {
          e.currentTarget.style.transform = 'translateY(-1px)';
        }
      }}
      {...props}
    >
      {children}
    </button>
  );
}
